import React from 'react'
import { Row, Card } from 'antd'
import { EmptyHeaderHero } from './components'

import NaicStyle from '../../styles/NAICNumbers.module.css'

const NAICNumbers = () => {
  return (
    <>
      <EmptyHeaderHero title="NAIC Numbers" />
      <div className={`${NaicStyle["naic-numbers-screen"]}`}>
        <Row>
          <Card className={`${NaicStyle["naic-numbers-card"]} ${NaicStyle["desktop-view"]}`}>
            <p className={`${NaicStyle["naic-text"]}`}>
              If you are a <span>Michigan</span> policyholder, our NAIC code is <span>37028</span>.
            </p>
            <p className={`${NaicStyle["naic-text"]}`}>
              If you are a <span>New Jersey</span> policyholder, our NAIC code is <span>37028</span>. Our{' '}
              <span>New Jersey</span> insurance code is <span>946</span>.
            </p>
            <p className={`${NaicStyle["naic-text"]}`}>
              If you are a <span>Pennsylvania</span> policyholder, our NAIC code is <span>37028</span>.
            </p>
            <h5>Looking for your policy number?</h5>
            <p>
              Your policy number can be found on your insurance ID card, declarations page and installment billing
              notices.
            </p>
          </Card>
          <Card className={`${NaicStyle["naic-numbers-card"]} ${NaicStyle["mobile-view"]}`}>
            <p className={`${NaicStyle["naic-text"]}`}>CURE NAIC code is 37028 for all states.</p>
            <p className={`${NaicStyle["naic-text"]}`}>CURE New Jersey insurance code is 946.</p>
            <h5>Looking for your policy number?</h5>
            <p>
              Your policy number can be found on your insurance ID card, declarations page and installment billing
              notices.
            </p>
          </Card>
        </Row>
      </div>
    </>
  )
}

NAICNumbers.propTypes = {}

export default NAICNumbers
